module.exports = __webpack_public_path__ + "img/sti.b02d51fb.svg";